import { jsxs as _jsxs } from "react/jsx-runtime";
import Typography from "@mui/material/Typography";
export default function TicketProgressColumn({ progress }) {
    return _jsxs(Typography, { children: [progress, "%"] });
}
